module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-3.e89e1497.png";